import styled, { keyframes } from "styled-components";
import { Icon as IconElement, IconNames } from "../Icon";

interface PusingIconProps {
  icon: IconNames;
  size?: number;
  padding?: number;
  color?: string;
  centerColor?: string;
  centerBorderColor?: string;
  centerBorderSize?: number;
  ringBackgroundColor?: string;
  ringColor?: string;
  ringSize?: number;
}
export const PulsingIcon = ({
  icon,
  size = 32,
  padding = 16,
  color,
  centerColor = "red",
  centerBorderColor = "transparent",
  centerBorderSize = 0,
  ringBackgroundColor = "transparent",
  ringColor = "red",
  ringSize = 2,
}: PusingIconProps) => (
  <MainContainer size={size} padding={padding}>
    <IconContainer
      size={size}
      padding={padding}
      borderSize={centerBorderSize}
      borderColor={centerBorderColor}
      backgroundColor={centerColor}
      color={color}
    >
      <Icon name={icon} height={`${size}px`} width={`${size}px`} />
    </IconContainer>
    <PulseWave
      size={size}
      padding={padding}
      borderSize={ringSize}
      borderColor={ringColor}
      backgroundColor={ringBackgroundColor}
    />
    <PulseWave
      size={size}
      padding={padding}
      borderSize={ringSize}
      borderColor={ringColor}
      backgroundColor={ringBackgroundColor}
    />
  </MainContainer>
);

const WaveAnimation = keyframes`
from {
  opacity: 1;
  scale: 1;
}
to {
  opacity: 0;
  scale: 1.6;
}`;

const PulseAnimation = keyframes`
0%, 16%, 48%, 80%, 100% {
  scale: 1;
}
32%, 64% {
  scale: 1.1;
}
`;

interface BaseElementProps {
  size: number;
  padding: number;
  borderSize?: number;
  borderColor?: string;
  backgroundColor?: string;
}

const BaseElement = styled.div<BaseElementProps>`
  display: block;
  border-radius: ${(p) => p.size + p.padding}px;
  position: relative;
  width: ${(p) => p.size + p.padding * 2}px;
  height: ${(p) => p.size + p.padding * 2}px;
  padding: 0;
  align-self: center;
  justify-self: center;
`;

const MainContainer = styled(BaseElement)`
  width: ${(p) => p.size + p.padding * 2}px;
  height: ${(p) => p.size + p.padding * 2}px;
`;

const Icon = styled(IconElement)`
  scale: 1;
  animation: ${PulseAnimation} 3s infinite;
`;

const IconContainer = styled(BaseElement)<{ color?: string }>`
  z-index: 1;
  ${(p) => p.color && `color: ${p.color}`};
  padding: ${(p) => p.padding - p.borderSize}px;
  position: absolute;
  border: ${(p) => `${p.borderSize}px solid ${p.borderColor}`};
  background: ${(p) => `${p.backgroundColor}`};
`;

const PulseWave = styled(BaseElement)`
  animation: ${WaveAnimation} 3s infinite;
  opacity: 1;
  scale: 1;
  z-index: 0;
  position: absolute;
  border: ${(p) => `${p.borderSize}px solid ${p.borderColor}`};
  background: ${(p) => `${p.backgroundColor}`};
  &:nth-of-type(2) {
    animation-delay: 0.5s;
  }
  &:nth-of-type(3) {
    animation-delay: 1.5s;
  }
`;
